import { render, staticRenderFns } from "./CardApontamento.vue?vue&type=template&id=a0871dd0&scoped=true"
import script from "./CardApontamento.vue?vue&type=script&lang=js"
export * from "./CardApontamento.vue?vue&type=script&lang=js"
import style0 from "./CardApontamento.vue?vue&type=style&index=0&id=a0871dd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0871dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0871dd0')) {
      api.createRecord('a0871dd0', component.options)
    } else {
      api.reload('a0871dd0', component.options)
    }
    module.hot.accept("./CardApontamento.vue?vue&type=template&id=a0871dd0&scoped=true", function () {
      api.rerender('a0871dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardApontamento.vue"
export default component.exports